import {IMarkerClusterGroupInstance, LeafletClusterProps} from "@ui/leafletCustom/leafletCluster/types";
import {transformEventName} from "@ui/leafletCustom/leafletCluster/helpers/transformEventName";

export function updateMarkerCluster(instance: IMarkerClusterGroupInstance,
                                    props: LeafletClusterProps,
                                    prevProps: LeafletClusterProps) {
    if (props.iconCreateFunction !== prevProps.iconCreateFunction) {
        instance.options.iconCreateFunction = props.iconCreateFunction
        instance.refreshClusters()
    }

    if (props.onClick !== prevProps.onClick) {
        const onClickEventName = transformEventName('onClick')
        instance.removeEventListener(onClickEventName, prevProps.onClick)
        instance.addEventListener(onClickEventName, props.onClick)
    }

    if(props.hasRerenderOnChangeChildren && props.children !== prevProps.children){
        instance.refreshClusters()
    }


}

